import React from 'react';

import ViewChanger from './ViewChanger';
import CreateFolderButton from './CreateFolderButton';
import UploadFileButton from './UploadFileButton';
import CreateDocument from './CreateDocument';

import { useUserDetailsContext } from 'context/userDetailsContext';
import constants from 'constants/index';
import { useFileManagerContext } from 'modules/file_manager/context/FileManagerContext';
import Discrepancy from './Discrepancy';
import ExtractEntities from './ExtractEntities';
import CreateTimeline from './CreateTimeline';

function Menu() {
  const { isGlobalFileManager, isCaseFileManager, isLeadFileManager, isClientFileManager, isFirmDocuments } = useFileManagerContext();
  const { getPermission, checkSubPermission } = useUserDetailsContext();

  return (
    <>
      {/* Line 1: ViewChanger, Discrepancy, Create Document */}
      <div className="menu-row menu-row-top d-flex gap-2">
        <ViewChanger />
        {checkSubPermission('ai_find_discrepancies') && (isCaseFileManager || isLeadFileManager) ? <Discrepancy /> : null}
        {checkSubPermission('document_assembly') && !isGlobalFileManager && !isClientFileManager && <CreateDocument />}
      </div>

      {/* Line 2: Create Folder and Upload File */}
      {(getPermission('cases') === constants.permissions.WRITE || isClientFileManager) && (
        <div className="menu-row menu-row-middle d-flex gap-2">
          {(!isGlobalFileManager && !isClientFileManager) || isFirmDocuments ? <CreateFolderButton /> : null}
          {(isCaseFileManager || isClientFileManager || isLeadFileManager) && <UploadFileButton />}
        </div>
      )}

      {/* Line 3: Extract Entities and Create Timeline */}
      <div className="menu-row menu-row-bottom d-flex gap-2">
        {checkSubPermission('ai_extract_entities') ? !isGlobalFileManager && !isClientFileManager && <ExtractEntities /> : null}
        {checkSubPermission('ai_create_timeline') ? !isGlobalFileManager && !isClientFileManager && <CreateTimeline /> : null}
      </div>
    </>
  );
}

export default Menu;
